import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class RestService {
  private http = inject(HttpClient);

  private headers = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'Content-Type': 'application/json',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Accept: 'application/json'
  };

  public get$<T>(url: string): Observable<T> {
    return this.http.get(url).pipe(map(response => response as T));
  }

  public getHttp(): HttpClient {
    return this.http;
  }

  public post$<T>(url: string, item: any): Observable<T> {
    const options = { headers: new HttpHeaders(this.headers) };
    return this.http
      .post<T>(url, item, options)
      .pipe(map(response => response));
  }
  public put$<T>(url: string, item: any): Observable<T> {
    const options = { headers: new HttpHeaders(this.headers) };
    return this.http.put<T>(url, item, options).pipe(map(response => response));
  }

  public delete$<T>(url: string): Observable<T> {
    const options = { headers: new HttpHeaders(this.headers) };
    return this.http.delete<T>(url, options).pipe(map(response => response));
  }
}
